import type { EntryPoint, EntryPointComponent, PreloadFetchPolicy } from 'react-relay';

import traceUFOPress from '@atlaskit/react-ufo/trace-press';
import type { AnalyticsAttributes } from '@atlassian/projects-goals-common/analytics';
import { createPlatformSiteAri } from '@atlassian/projects-goals-common/create-platform-site-ari';
import { getSiteId } from '@atlassian/projects-goals-common/get-site-id';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, { type GoalPanelQuery } from './__generated__/GoalPanelQuery.graphql';
import type { ProductName, TabType } from './types';

type EntryPointParams = { ari: string };
const fetchPolicy: PreloadFetchPolicy = 'network-only';

const atlasGoalEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			queryReference: GoalPanelQuery;
		},
		Record<string, never>,
		{
			parentProduct: ProductName;
			cloudId: string;
			analyticsAttributes?: AnalyticsAttributes;
			organizationId?: string;
			url?: string;
			defaultTab?: TabType;
		},
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/GoalPanel" */ './GoalPanel'
			),
		{
			moduleId: 'atlas-goal-entrypoint',
		},
	),
	getPreloadProps: ({ ari }: EntryPointParams) => {
		traceUFOPress('townsquare-goal-panel-opened');

		const siteId = getSiteId('goal', ari);
		const queryContext = siteId ? createPlatformSiteAri(siteId) : null;

		return {
			queries: {
				queryReference: {
					parameters,
					variables: {
						ari,
						queryContext,
					},
					options: {
						fetchPolicy,
					},
				},
			},
		};
	},
});

export default atlasGoalEntryPoint;
